/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const GetEntitlements = /* GraphQL */ `query GetEntitlements($role: String!) {
  GetEntitlements(role: $role) {
    entitlements
    role
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEntitlementsQueryVariables,
  APITypes.GetEntitlementsQuery
>;
export const GetFileMetadata = /* GraphQL */ `query GetFileMetadata($fileId: String, $orgId: String) {
  GetFileMetadata(fileId: $fileId, orgId: $orgId) {
    description
    errors {
      count
      errorDetails
      __typename
    }
    exportStatus
    fileId
    fileName
    fileSize
    headers
    lastModifiedAt
    lastModifiedBy
    operatorsProcessed
    orgId
    recordCount
    rowsProcessedList
    s3Key
    s3OutputKeys
    templateId
    uploadBy
    uploadStatus
    uploadedAt
    validationResults
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFileMetadataQueryVariables,
  APITypes.GetFileMetadataQuery
>;
export const GetHealth = /* GraphQL */ `query GetHealth {
  GetHealth {
    environment
    status
    timestamp
    version
    __typename
  }
}
` as GeneratedQuery<APITypes.GetHealthQueryVariables, APITypes.GetHealthQuery>;
export const GetOrganizationList = /* GraphQL */ `query GetOrganizationList {
  GetOrganizationList {
    createdAt
    createdBy
    fileTemplateConfig {
      description
      displayName
      headers
      templateId
      __typename
    }
    landingBucketConfig {
      bucketName
      bucketPrefix
      bucketRegion
      __typename
    }
    lastModifiedAt
    lastModifiedBy
    numberOfFiles
    orgId
    orgName
    orgType
    status
    targetColumnMapping
    targetColumns {
      desc
      key
      tagName
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrganizationListQueryVariables,
  APITypes.GetOrganizationListQuery
>;
export const ListFileMetadata = /* GraphQL */ `query ListFileMetadata($input: FileListRequest!) {
  ListFileMetadata(input: $input) {
    items {
      description
      errors {
        count
        errorDetails
        __typename
      }
      exportStatus
      fileId
      fileName
      fileSize
      headers
      lastModifiedAt
      lastModifiedBy
      operatorsProcessed
      orgId
      recordCount
      rowsProcessedList
      s3Key
      s3OutputKeys
      templateId
      uploadBy
      uploadStatus
      uploadedAt
      validationResults
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFileMetadataQueryVariables,
  APITypes.ListFileMetadataQuery
>;
export const ValidateFile = /* GraphQL */ `query ValidateFile($input: ValidateFileInput!) {
  ValidateFile(input: $input) {
    extraColumns
    isValid
    matchedColumns
    missingColumns
    orgId
    rowValidation
    s3Key
    summary
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidateFileQueryVariables,
  APITypes.ValidateFileQuery
>;
export const ValidateHeaders = /* GraphQL */ `query ValidateHeaders($input: ValidateHeadersInput!) {
  ValidateHeaders(input: $input) {
    extraColumns
    isValid
    matchedColumns
    missingColumns
    orgId
    s3Key
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidateHeadersQueryVariables,
  APITypes.ValidateHeadersQuery
>;
